/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppOverviewRouteImport } from './routes/_app/overview'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppAccountsIndexRouteImport } from './routes/_app/accounts/index'
import { Route as AppAccountsIdRouteImport } from './routes/_app/accounts/$id'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppSettingsDebtsRouteImport } from './routes/_app/settings/debts'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountsIndexRoute = AppAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsIdRoute = AppAccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDebtsRoute = AppSettingsDebtsRouteImport.update({
  id: '/settings/debts',
  path: '/settings/debts',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/overview': typeof AppOverviewRoute
  '/reports': typeof AppReportsRoute
  '/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/accounts/$id': typeof AppAccountsIdRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/settings/debts': typeof AppSettingsDebtsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/accounts/': typeof AppAccountsIndexRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/overview': typeof AppOverviewRoute
  '/reports': typeof AppReportsRoute
  '/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/accounts/$id': typeof AppAccountsIdRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/settings/debts': typeof AppSettingsDebtsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/accounts': typeof AppAccountsIndexRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/overview': typeof AppOverviewRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounts/$id': typeof AppAccountsIdRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/settings/debts': typeof AppSettingsDebtsRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/accounts/': typeof AppAccountsIndexRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/overview'
    | '/reports'
    | '/trash'
    | '/auth/launch'
    | '/accounts/$id'
    | '/customers/$id'
    | '/settings/debts'
    | '/settings/users'
    | '/accounts/'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/overview'
    | '/reports'
    | '/trash'
    | '/auth/launch'
    | '/'
    | '/accounts/$id'
    | '/customers/$id'
    | '/settings/debts'
    | '/settings/users'
    | '/accounts'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/_app/overview'
    | '/_app/reports'
    | '/_app/trash'
    | '/auth/launch'
    | '/_app/'
    | '/_app/accounts/$id'
    | '/_app/customers/$id'
    | '/_app/settings/debts'
    | '/_app/settings/users'
    | '/_app/accounts/'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/overview': {
      id: '/_app/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/accounts/': {
      id: '/_app/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AppAccountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts/$id': {
      id: '/_app/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof AppAccountsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/debts': {
      id: '/_app/settings/debts'
      path: '/settings/debts'
      fullPath: '/settings/debts'
      preLoaderRoute: typeof AppSettingsDebtsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppOverviewRoute: typeof AppOverviewRoute
  AppReportsRoute: typeof AppReportsRoute
  AppTrashRoute: typeof AppTrashRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountsIdRoute: typeof AppAccountsIdRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppSettingsDebtsRoute: typeof AppSettingsDebtsRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppAccountsIndexRoute: typeof AppAccountsIndexRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOverviewRoute: AppOverviewRoute,
  AppReportsRoute: AppReportsRoute,
  AppTrashRoute: AppTrashRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountsIdRoute: AppAccountsIdRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppSettingsDebtsRoute: AppSettingsDebtsRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppAccountsIndexRoute: AppAccountsIndexRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
